import Modal from "components/common/Modal";
import React, { FC } from "react";
import { regextForDiv } from "utils/utils";
import HtmlRenderer from "./HtmlRenderer";

interface ZoneModal {
  isOpen: any;
  onClose: any;
  content: any;
  heading: any;
}

const ZoneModal: FC<ZoneModal> = ({ isOpen, onClose, content, heading }) => {
  if (regextForDiv.test(content)) {
    return <HtmlRenderer heading={heading} isOpen={isOpen} onClose={onClose} content={content} />;
  }
  const zoneLabels = ["ZONE A", "ZONE B", "ZONE C"];
  const transposedData = zoneLabels.map((label, i) => ({
    zone: label,
    values: content && content.map((entry: any) => entry.zones[i])
  }));

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="w-[35rem] pb-2" headerClassName="bg-[#F0F4FD] -mt-5 py-5 rounded-t-lg" header={<p className="font-bold">{heading}</p>}>
      <div className="pl-5 pt-5 pr-5 max-h-[26rem] overflow-auto custom-scrollbar ">
        <table className="w-full">
          <tr className="bg-[#F0F4FD] text-sm font-bold p-5 justify-between w-full">
            <td className="p-3">Sum Insured</td>
            {content?.map((entry: any) => {
              return (
                <td key={entry.sumInsured} style={{ padding: "8px" }}>
                  Rs. {entry.sumInsured / 100000} Lakh
                </td>
              );
            })}
          </tr>
          {transposedData &&
            transposedData.map((row: any, index: number) => {
              return (
                <tr key={index} className="p-5 border-dashed border-[1px] border-l-0 border-r-0">
                  <td className={`flex gap-3  p-4 border-dashed border-[1px] border-b-0 border-l-0 border-r-0 border-t-0 items-center ${index == content.length - 1 && "border-b-2 border-dashed border-[1px]"}`}>
                    <span className="bg-[#C4C678] w-2 h-2 "></span>
                    <div className="font-bold text-sm "> {row.zone}</div>
                  </td>
                  {row.values.map((value: any, colIndex: number) => (
                    <td key={colIndex} style={{ padding: "8px" }}>
                      {value}
                    </td>
                  ))}
                </tr>
              );
            })}
        </table>
      </div>
    </Modal>
  );
};

export default ZoneModal;
